import React, { useEffect, useState } from "react";
import '../styles/dashboard.css';
import ImageButton from "../components/inputs/ImageButton";
import locate from '../assets/images/location.png';
import book from '../assets/images/booking.png';
import about from '../assets/images/about.png';
import other from '../assets/images/other-patient.png';
import holidays from '../assets/images/holiday.png';
import lab from '../assets/images/laboratory.png';
import LeftSideBar from "../components/LeftSidebar";
import { useAuth } from "../context/AuthContext";
import useCustomNavigate from "../hooks/useCustomNavigate";
import { getLogo } from "../helpers/Helpers";

const Dashboard = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const navigate = useCustomNavigate();
    const Auth = useAuth();
    useEffect(() => {
        if (localStorage.getItem("life-other-patient")) {
            localStorage.removeItem("life-other-patient");
        }
    })
    return (
        <div className="dashboard-container">
            <div className="header">
                <div className="patient-detail">
                    <div className="welcome-text">
                        Welcome,
                    </div>
                    <div className="name-text">
                        { Auth.getUser().data.patients[0] ? Auth.getUser().data.patients[0].patientName : '' }
                    </div>
                </div>
                <div className="image-container">
                    <i className="las la-sliders-h" onClick={() => { setShowSidebar(prev=> !prev); }}/>
                </div>
            </div>
            <div className="hospital-branding">
                {getLogo()}
            </div>
            <div className="mid-header">
                Features For You
            </div>
            <div className="links-container">
                <ImageButton image={locate} label="Locate Us" onClick={() => { window.open(process.env.REACT_APP_MAP_URL) }} />
                <ImageButton image={book} label="Booking" onClick={() => { navigate('/departments', { forOtherPatient: false }) }} />
                <ImageButton image={lab} label="Lab Results" onClick={() => { navigate('/labresults') }} />
                {Auth.getUser().data.checknon ? <></> :
                    <ImageButton image={other} label="Book For Other" onClick={() => { navigate('/otherpatient'); }} />
                }
                <ImageButton image={holidays} label="Holidays" onClick={() => { navigate('/holidays'); }} />
                <ImageButton image={about} onClick={() => { navigate('/about'); }} label="About Us"/>
            </div>
            <LeftSideBar show={showSidebar} onClose={() => { setShowSidebar(prev => !prev); }} />
        </div>
    )
}
export default Dashboard;